import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { TranslationManagerService } from '@globalization/services/translation-manager.service';
import { IUsersService } from '@shared/interfaces/users-service.interface';

@Component({
    selector: 'bv-login-idp',
    template: '<div></div>',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AccountLoginIdpComponent implements OnInit {
  public returnUrl!: string;
  private route: ActivatedRoute = inject(ActivatedRoute)
  private translationManagerService: TranslationManagerService = inject(TranslationManagerService);
  private usersService: IUsersService = inject(IUsersService);

  public ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const lang = params.get('lang');
      if (lang) {
        this.translationManagerService.setCurrentLang(lang);
      }
    });

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.usersService.signInRedirect(this.returnUrl);
  }
}
